import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PACKAGES_BASE_QUERY_KEY } from '@/api/packages/get-packages-dashboard'
import { resetQueries } from '@/utils/api'

interface BulkArchivePackagesRequest {
  ids: number[]
}

export const bulkArchivePackages = async (data: BulkArchivePackagesRequest): Promise<void> => {
  await authAPI.put('/packages/bulk-archive', data)
}

export const useBulkArchivePackages = () => {
  return useMutation({
    mutationFn: bulkArchivePackages,
    onSuccess: () => {
      resetQueries([PACKAGES_BASE_QUERY_KEY])
    },
  })
}
